import * as React from 'react'
import { useParams } from 'react-router-dom'

import moment from 'moment'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'

import type { GroupType, ViewType } from 'modules/shift_management/store/internal/models/View'
import View from 'modules/shift_management/store/internal/models/View'

import scheduleReducer, {
  ScheduleDispatch,
  ScheduleState,
  initialScheduleState,
} from './reducers/schedule'

type Context = [ScheduleState, ScheduleDispatch]

const { context: ScheduleContext, hook: useSchedule } = createContext<Context>()

const ScheduleProvider = ({ children }: React.PropsWithChildren<object>) => {
  const params = useParams()
  const { year, month, day } = params
  const viewType = params.viewType as ViewType
  const groupType = params.groupType as GroupType
  const dateFromParams = moment([Number(year), Number(month) - 1, Number(day)])
  const date = dateFromParams.isValid() ? dateFromParams : moment()
  const view = new View({ date, viewType, groupType })

  const memoizedReducer = useCallback(scheduleReducer, [])
  const [state, dispatch] = React.useReducer(
    memoizedReducer,
    initialScheduleState({ args: { schedule: { view } } })
  )

  return <ScheduleContext.Provider value={[state, dispatch]}>{children}</ScheduleContext.Provider>
}

export { ScheduleProvider, useSchedule }
